<div class="row">
  <div class="col-md-12">
    <app-card [showHeader]="false" padding="15" cardClass="social-widget-card">
      <div class="text-warn-500">Errors</div>

      <h3 class="m-b-5 f-w-500">
        @if (isLoading){
          <span class="col-span-1 h-4 rounded bg-gray-500/40 my-5 animate-pulse">
            <span class="opacity-0">Cargando ...</span>
          </span>
        } @else {
          <span class="text-warn-500">
            {{ diagnostic?.errors['total']?.length || 0 }}
          </span>
          <span class="text-warn-200">
            ({{ (diagnostic?.errors['total']?.length  / positions.length * 100).toFixed(2) }}%)
          </span>
        }
      </h3>

      <i class="fa-regular fa-bell"></i>
    </app-card>
  </div>

  <div class="col-md-6">
    <app-card [showHeader]="false" padding="15" cardClass="social-widget-card">
      <div class="text-amber-500">Rechazadas</div>

      <h3 class="m-b-5 f-w-500">
        @if (isLoading){
          <span class="col-span-1 h-4 rounded bg-gray-500/40 my-5 animate-pulse">
            <span class="opacity-0">Cargando ...</span>
          </span>
        } @else {
          <span class="text-amber-500">
            {{ diagnostic?.errors['trashed']?.length || 0 }}
          </span>
          <span class="text-amber-200">
            ({{ (diagnostic?.errors['trashed']?.length  / positions.length * 100).toFixed(2) }}%)
          </span>
        }
      </h3>

      <i class="fa-regular fa-bell"></i>
    </app-card>
  </div>

  <div class="col-md-6">
    <app-card [showHeader]="false" padding="15" cardClass="social-widget-card">
      <div class="text-amber-500">Mal procesadas</div>

      <h3 class="m-b-5 f-w-500">
        @if (isLoading){
          <span class="col-span-1 h-4 rounded bg-gray-500/40 my-5 animate-pulse">
            <span class="opacity-0">Cargando ...</span>
          </span>
        } @else {
          <span class="text-amber-500">
            {{ diagnostic?.errors['prevElementIncorrect']?.length || 0 }}
          </span>
          <span class="text-amber-200">
            ({{ (diagnostic?.errors['prevElementIncorrect']?.length  / positions.length * 100).toFixed(2) }}%)
          </span>
        }
      </h3>

      <i class="fa-regular fa-bell"></i>
    </app-card>
  </div>
</div>
